import {Company} from '@tinct/core-api-models';
import {ApiClient} from '../api-client/api-client';
import {ApiCollectionResponse, GetCollectionQueryParams, GetQueryByIdParams,} from '../types';

export interface LookupCompaniesParams {
  term: string;
}

export interface GetCompaniesFilter {
  term?: string;
}

export class CompaniesEndpoint {
  constructor(private client: ApiClient) {}

  async getCompany(params: GetQueryByIdParams<Company>): Promise<Company> {
    return this.client.getById<Company>(
      `/api/v1/companies/${params.id}`,
      params.fields,
    );
  }

  async getCompanies(
    params: GetCollectionQueryParams<Company>,
  ): Promise<ApiCollectionResponse<Company>> {
    const { fields, offset, limit, filters } = params;
    return this.client.getCollection<Company>('/api/v1/companies', fields, {
      offset,
      limit,
      ...filters,
    });
  }

  async lookupCompanies(
    params: LookupCompaniesParams,
  ): Promise<Company[]> {
    return this.client.getById<Company[]>('/api/v1/companies/_lookup', undefined, {
      params: { term: params.term },
    });
  }
}
